'use strict';

(function() {

    /** @namespace Fotobook.calendar */
    Fotobook.calendar = {

        getPrintPageNum: function (page) {
            return Fotobook.book.getPrintPageNum(page);
        }
    };
})();